/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_tq.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions TQ */
HafasWebapp.prototype.subscriptions.tq = function (_me) {
  Hafas.ps.sub('/tq/showTrainroute', Hafas.bind(_me.Controller.TQ.showResult, _me));
  Hafas.ps.sub('/tq/hideTrainroute', Hafas.bind(_me.Controller.TQ.hideResult,_me));
  Hafas.ps.sub('/tq/selectStation', Hafas.bind(_me.Controller.TQ.selectStation,_me));

  Hafas.ps.sub('/GUI/leaveContext/TQ', Hafas.bind(_me.Controller.TQ.cleanup,_me));
  Hafas.ps.sub('/GUI/closeView/TQ', Hafas.bind(_me.Controller.TQ.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/TQ', Hafas.bind(_me.Controller.TQ.restoreView,_me));

  Hafas.ps.sub('/GUI/map/show', Hafas.bind(_me.Controller.TQ.centerTrainroute,_me));
};